import Vue from 'vue';
import rentalService from '../../../services/rental';
import countryService from '../../../services/country';
import mixin from '../../../mixins/mixin';
import TimePicker from 'vue2-timepicker';
import RentalItemBlock from './RentalItemBlock';


export default {
  data() {
    return {
      loading: true,
      onInitializingLoading: false,
      mode: 'grid',
      rentals: [],
      success: false,
      error: null,
      uninitialized_count: 0,
      activeStep: 0,
      countries: [],
      image: {},
      user: {
        currency: {},
      },
      showGetStartedStep: false,
      groups: [],
      selectedGroup: {
        ids: [],
        rentals: [],
      },
      isInitializedErrors: false,
      cutOffHours: [],
      minutes: ['00'],
      checkinMinutes: ['00', '15', '30', '45'],
      checkinHours: [],
    };
  },
  components: {
    RentalItemBlock,
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    VImportNewAirbnbRentals: require('../../account/settings/modals/ImportNewAirbnbRentals'),
    VueTimepicker: TimePicker,
  },
  mixins: [mixin],
  async mounted() {
    let vm = this;

    $('.input-file-now').dropify({
      messages: {
        'default': 'Drag and drop a file here or click',
        'replace': 'Drag and drop or click to replace',
        'remove':  'Remove',
        'error':   'Ooops, something wrong happended.'
      }
    });
    if (this.account) {
      this.mode = localStorage.getItem(`rental_${this.account.id}_page`) ? localStorage.getItem(`rental_${this.account.id}_page`) : 'grid';
    }
    await rentalService.getGroups(vm);
    await vm.get_all();
    const progress = this.user.isSyncInProgress;
    if(vm.rentals.length > 0 && vm.uninitialized_count > 0 && progress !== 1 && vm.$route.path === '/rentals') {
      await vm.openModal('.onInitializing-modal');
    }
    await vm.get_countries();
    $('.right-rentals').css('max-height', '560px');

    this.initRentalCutOffHours();
  },
  async destroyed() {
    await this.closeModal('.onInitializing-modal');
  },
  methods: {
    async initialize_rental(rental){
      let vm = this;
      vm.onInitializingLoading = true;
      let img = vm.image;
      let image = {"image": img};

      let formData = new FormData();
      formData.append('image', img);
      formData.append('folder', 'rentals');

      if (img.name) {
        //TODO Use Service for files request
        await Vue.$http.post('/files', formData).then((response) => {
          if (response && response.status === 200) {
            rental.image = response.data.image;
          }
        }).catch((error) => {
          if (error.response) {
            toastr.error(error.response.data.msg.image[0]);
          }
        });
      } else {
        rental.image = null;
      }

      rental.invoice_name = rental.name;
      rental.invoice_address = rental.address;
      rental.invoice_zip_code = rental.zip_code;
      rental.invoice_city = rental.city;
      rental.invoice_country = rental.country_id;
      if (rental.price_extra) {
        rental.price_extra = Math.round(rental.price_extra);
      }

      await rentalService.update(rental.id, rental, vm);
      vm.image = {};
      if (!vm.isInitializedErrors) {
        if(this.notInitializedRentals.length - 1 > vm.activeStep ) {
          vm.activeStep++;
        } else if(vm.notInitializedRentals.length - 1 === vm.activeStep) {
          vm.showGetStartedStep = true;
          vm.activeStep++;
          this.closeModal('.onInitializing-modal');
        }
      }
      vm.onInitializingLoading = false;
    },
    async get_all(){
      let vm = this;
      await rentalService.get(vm);
    },
    new_rental (){
      Vue.router.push({
        name: 'rentals.create',
      });
    },
    edit (id){
      Vue.router.push({
        name: 'rentals.detail',
        params: { id: id }
      });
    },
    async get_countries(){
      let vm = this;
      await countryService.get(vm);
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.image = files[0];
    },
    async createGroup() {
      let vm = this;
      vm.selectedGroup = {
        ids: [],
        rentals: []
      };
      await vm.checkIfRentalExists(vm.selectedGroup);
      vm.openModal('#groups-modal');
    },
    async addGroup() {
      let vm = this;
      vm.rentals.forEach(rental => {
        if(rental.checked) {
          vm.selectedGroup.ids.push(rental.id);
        }
      });
      await rentalService.addGroup(vm, vm.selectedGroup);
      vm.closeModal('#groups-modal');
      mixpanel.track('web.rentals.create.group');
    },
    async getGroups() {
      await rentalService.getGroups(this);
    },
    async editGroup(id) {
      let vm = this;
      let group = vm.groups.filter(group => group.id === id)[0];
      vm.selectedGroup = Object.assign({}, group);
      await vm.checkIfRentalExists(group);
      vm.openModal('#groups-modal');
    },
    async updateGroup() {
      let vm = this;
      vm.selectedGroup.rentals = vm.rentals.filter(r => r.checked === true);
      await rentalService.updateGroup(vm, vm.selectedGroup.id, vm.selectedGroup);
    },
    async deleteGroup(id) {
      let vm = this;
      vm.closeModal('#groups-modal');
      swal({
            title: vm.$t('swal_popup.are_you_sure'),
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-warning",
            confirmButtonText: vm.$t('swal_popup.confirm_delete'),
            cancelButtonText: vm.$t('swal_popup.cancel'),
            closeOnConfirm: true,
            html: true
          },
          await function() {
            rentalService.deleteGroup(vm, id);
          });
    },
    checkIfRentalExists(group) {
      let vm = this;
      vm.rentals.forEach(rental => {
        let index = group.rentals.findIndex(g => g.id === rental.id);
        Vue.set(rental, 'checked', (index !== -1));
      });
      return true;
    },
    openImportNewRentalsModal() {
      this.$refs.airbnbImportModal.openImportNewRentalsModal();
    },
    initRentalCutOffHours() {
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < this.minutes.length; j++) {
          if (i === 0) {
            continue;
          }
          i < 10 ? this.cutOffHours.push(`0${i}:${this.minutes[j]}`) : this.cutOffHours.push(`${i}:${this.minutes[j]}`);
        }
        for (let j = 0; j < this.checkinMinutes.length; j++) {
          i < 10 ? this.checkinHours.push(`0${i}:${this.checkinMinutes[j]}`) : this.checkinHours.push(`${i}:${this.checkinMinutes[j]}`);
        }
      }
    },
    changeMode(mode) {
      this.mode = mode;
      if (this.account) {
        localStorage.setItem(`rental_${this.account.id}_page`, mode);
      }
    },
  },
  watch: {
    'account.lang': function (val) {
      if (val) {
        this.mode = localStorage.getItem(`rental_${this.account.id}_page`) || 'grid';
      }
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    notInitializedRentals() {
      return this.rentals.filter(rental => rental.is_initialized === 0);
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/rentals/index/index.js